import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
// Brand typefaces (UID-5 S9 resolution): Museo Sans (body) + Museo Slab
// (headings), self-hosted via ./styles/fonts.css. These are the design
// system's real licensed fonts — the @fontsource/mulish substitute that
// previously stood in here is retired. Only the 500 (regular) and 700 (bold)
// weights the token scale uses are loaded — see tokens.css §4's
// --font-weight-regular (500, NOT 400) / --font-weight-bold (700) mapping.
// Self-hosted files (no npm dependency, no third-party network / CSP concern).
import './styles/fonts.css'
import './styles/global.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element (#root) not found — check index.html.')
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
